<template>
<span>
  <v-row class="pa-0 ma-0">
    <v-col cols="6" class="pa-0 ma-0">
      <v-menu
          v-model="datePickerVisible"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <span
              v-if="!isOutlined"
              v-bind="attrs"
              v-on="on"
          >
            <span class="text-no-wrap">
              <v-icon x-small class="pr-1">fa-calendar-alt</v-icon><span class="dashed">{{ currentDate }}</span>
            </span>
          </span>
          <v-text-field
                hide-details
                v-if="isOutlined"
                :outlined="isOutlined"
                v-model="currentDate"
                readonly
                :label="dateLabel ? dateLabel : ''"
                v-bind="attrs"
                v-on="on"
            >
              <v-icon
                  slot="append"
                  v-on="on"
              >
                mdi-calendar
              </v-icon>
            </v-text-field>
        </template>
        <v-date-picker
            :first-day-of-week="first_day_of_week"
            :min="minDate"
            v-model="currentDate"
            @input="datePickerVisible = false; "
            :locale="locale"
        >
        </v-date-picker>
      </v-menu>
    </v-col>
    <v-col cols="6" class="pa-0 ma-0">
      <v-menu

          ref="timePicker"
          v-model="timePickerVisible"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="currentTime"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-if="!isOutlined">
            <v-icon x-small class="pl-2">fa-clock</v-icon>
            <span
                v-bind="attrs"
                v-on="on"
                class="dashed"
            >
              {{ currentTime }}
            </span>
          </span>
          <v-text-field
              class="ml-3"
              hide-details
              v-if="isOutlined"
              :outlined="isOutlined"
              v-model="currentTime"
              :label="timeLabel ? timeLabel : ''"
              readonly
              v-bind="attrs"
              v-on="on"
          >
            <v-icon
                slot="append"
                v-on="on"
            >
              mdi-clock
            </v-icon>
          </v-text-field>
        </template>
        <v-time-picker
            :min="minTime"
            v-if="timePickerVisible"
            v-model="currentTime"
            format="24hr"
            @click:minute="savetime(currentTime)"
        ></v-time-picker>
      </v-menu>
    </v-col>
  </v-row>
</span>
</template>

<script>
import CommonMixin from "@/mixins/common";

export default {
  name: "DateTimePicker",
  mixins: [CommonMixin],
  props: ['dateTime', 'minTime', 'minDate', 'date', 'time', 'outlined', 'dateLabel', 'timeLabel', 'notRound'],
  data: () => ({
    datePickerVisible: false,
    timePickerVisible: false,
  }),
  computed: {
    isOutlined() {
      return !(this.outlined === false || this.outlined === undefined);
    },
    currentDate: {
      get: function () {
        let parsed;
        if (this.dateTime) {
          parsed = (typeof this.dateTime === "string") ? this.dateTime.substring(0, 10) : this.dateToTimestamp(this.dateTime).substring(0, 10);
        }
        return (this.date) ? this.date : parsed;
      },
      set: function (date) {
        if (this.dateTime) {
          this.$emit('update:date-time', `${date} ${this.currentTime}`);
        } else {
          this.$emit('update:date', date)
        }
        this.$emit('change', `${date} ${this.currentTime}`);
      }
    },
    currentTime: {
      get: function () {
        let parsed;
        if (this.dateTime) {
          parsed = (typeof this.dateTime === "string") ? this.dateTime.substring(11).substring(0, 5) : this.dateToTimestamp(this.dateTime).substring(11).substring(0, 5);
        }
        return (this.time) ? this.time : parsed;
      },
      set: function (time) {
        if (this.dateTime) {
          this.$emit('update:date-time', `${this.currentDate} ${time}`);
        } else {
          this.$emit('update:time', time)
        }
        this.$emit('change', `${this.currentDate} ${time}`);
      }
    }
  },
  methods: {
    savetime(currentTime){
      if(this.notRound){
        this.$refs.timePicker.save(currentTime)
      } else {
        this.$refs.timePicker.save(this.roundTimeTo15min(currentTime))
      }
    }
  }
}
</script>

<style scoped>

</style>